// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f680dd0c","239":"46ed79b7","732":"ba069b42"}[chunkId] + ".chunk.js";
};